import { parseAddress } from 'humanparser';

interface ResponseData {
  name: string;
  url: string;
}

export default class ContentLocation {
  responseData: ResponseData;

  constructor(responseData: ResponseData) {
    this.responseData = responseData;
  }

  get displayName(): string {
    return `${this.city}, ${this.stateAbbreviation}`;
  }

  get valid(): boolean {
    return !!this.city && !!this.stateAbbreviation;
  }

  get city(): string {
    return parseAddress(this.responseData.name).city;
  }

  get stateAbbreviation(): string {
    return parseAddress(this.responseData.name).state;
  }

  get url(): string {
    return this.responseData.url;
  }
}
